import { createFileRoute } from '@tanstack/react-router';

import ResetPassword from '@/pages/ResetPassword';

export const Route = createFileRoute('/_app/reset-password/$token')({
  component: ResetPassword,
});
